import { snakeStore, DATA } from '@app/plugins/vuex-async-pagginate';
import { StatService } from '@phone-number/services/StatService';

export const detailed = snakeStore(
  {
    actions: {
      getData: ({ commit }, params) => {
        return StatService.getDetailed(params).then((response) => {
          if (response.data?.length === 0) {
            commit(DATA, response.data);
            return response.data;
          } else {
            let modify_data = [
              ...response.data,
              {
                number: 'total',
                total_number_count: response.total_number_count,
                status: null,
                subscription_fee: response.total_subscription_fee,
                subscription_fee_count: response.total_subscription_fee_count,
                payment_sum: response.total_payment_sum,
                last_payment_date: null
              }
            ];

            commit(DATA, modify_data);
          }
        });
      }
    }
  },
  true
);
